<template>
    <div>
        <div class="row  no-gutters pt-xl-4 mb-xl-6">
            <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
                 v-if="lesson">
                {{lesson.lesson}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points && testmode==0">
                <div class="zerno-points">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1">{{ $t('test') }} {{$t('№')}}{{ test.pos }}
                    <span class="ml-2" v-if="testsCount > 0">({{test.pos}} {{$t('of')}} {{testsCount}})</span>
                </div>
            </div>

            <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

                <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
                <h2 class="mt-7" v-else>{{ $t('test') }} {{$t('№')}}{{ test.pos }}</h2>
                <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
                <button
                        class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                        @click="startTest">
                    <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{$t('№')}}{{ test.pos }}
                </button>

            </div>

            <div class="col-12 order-10" v-if="!showTestIntro && test">

                <div class="row ml-xl-0 mr-xl-0 ml-3 mr-3 justify-content-center">

                    <div class="col-xl-12 col-12 test-question-content text-center mt-xl-n4"
                         v-if="currentTask.testtask"
                         @click="play(mainElement.audio)">
                        <span v-if="currentTask.pos && !currentTask.testtask.startsWith($t('№')+currentTask.pos)"
                              class="mr-3">{{$t('№')}}{{currentTask.pos}}.</span>{{ currentTask.testtask }}
                    </div>

                    <div class="col-12 tab-video-notice-2 text-center pl-xl-0 pl-6 pr-xl-0 pr-6 mb-xl-4"
                         v-if="test.description && test.description !== currentTask.testtask">{{
                        test.description }}
                    </div>

                    <div class="col-xl-12 col-12 mb-xl-4 mb-4 mt-2">

                        <div class="row">
                            <div class="offset-0 offset-xl-1 col-xl-7 col-12 hidden-test-image"
                                 :style='`background-image: url("${mainElement.image}");`'>
                                <div class="pa-1" style="padding: 0; margin: 0;">
                                    <div class="row">
                                        <div
                                                v-for="(state, i) in cover"
                                                :key="i"
                                                class="ma-0 col-3 hidden-card-wrapper">
                                            <div v-show="state" class="hidden-card pa-0 ma-0"/>
                                        </div>
                                    </div>
                                </div>
                                <!--</img> -->
                            </div>
                            <div class="col-xl-3 col-12 mb-5">
                                <div class="row text-center justify-content-around">
                                    <div class="col-xl-12 col-12 mb-3 mt-xl-0 mt-3 ml-xl-8 ml-0">
                                        <button
                                                class="btn btn-secondary btn-success btn-lg hide-yey-btn mb-12"
                                                @click="openCovers"
                                        >
                                            <i class="fa fa-eye"></i>
                                        </button>
                                    </div>

                                    <div class="col-xl-12 col-auto mb-xl-2 mb-3 ml-xl-8 ml-0 px-0"
                                         v-for="(item, i) in answers"
                                         :key="i">
                                        <button
                                                :class="['btn', 'test-question-btn', item.color?item.color:'btn-secondary']"
                                                @click="next(item)">
                                            {{ item.word }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
                <button
                        class="btn btn-info"
                        @click="skip"
                >
                    {{ $t('omit_task') }} &rarr;
                </button>
        </div>
    </div>
</template>
<style src="@/assets/poliglotiki/main.css">
</style>
<script>
    import Vue from 'vue'
    import api from '@/utils/api'

    export default {
        name: 'Test4',
        props: {
            idtest: {default: null},
            lesson: {type: Object, default: null},
            points: {default: null},
            testsCount: {default: null},
            showButtons: {type: Boolean, default: true},
            testmode: {default: 0},
        },

        data: () => ({
            test: {},
            testtasks: [],
            testelements: [],
            taskIdx: 0,
            audio: new Audio(),

            cover: Array(16).fill(true),
            forceRenderKey: 0,

            showTestIntro: true,
            //errorChord: 'gong.mp3',
            errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
            okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',
        }),

        computed: {
            currentTask: function () {
                console.log('currentTask')
                return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
            },

            mainElement: function () {
                console.log('mainElement', this.getBy('ismain', 1, this.testelements))
                return this.getBy('ismain', 1, this.testelements)
            },

            answers: function () {
                console.log('answers')
                return this.testelements.filter(function (e) {
                    return !e.ismain
                })
            },
        },

        watch: {
            taskIdx: async function () {
                this.loadTask()
            },
        },

        async mounted() {
            api({url: '/tests/' + this.idtest}).then(resp => {
                this.test = resp.data
            })
            const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
            this.testtasks = response.data
            this.loading = false
        },
        methods: {
            async startTest() {
                if (this.testtasks.length) {
                    if (this.test.audio) {
                        await this.play(this.test.audio)
                    }
                    this.showTestIntro = false
                    this.loadTask()
                }
            },
            async loadTask() {
                if (this.currentTask.idtesttask) {
                    this.cover = Array(16).fill(true)
                    const response = await api({
                        method: 'get',
                        url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
                    })
                    this.testelements = response.data
                    console.log(this.taskIdx, this.currentTask, this.mainElement)
                } else {
                    this.$emit('testComplete')
                }
            },
            openCovers() {
                let left = 3
                let step = 50
                while (left && step) {
                    step--
                    const idx = Math.floor(Math.random() * 16)
                    if (this.cover[idx]) {
                        this.cover[idx] = false
                        left--
                    }
                }

                this.cover = this.cover.slice() // clone
            },

            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            play: function (path) {
                return new Promise((resolve) => {
                    if (path) {
                        this.audio.src = path
                        this.audio.play()
                        this.audio.onended = function () {
                            console.log('Звук закончился')
                            resolve()
                        }

                        this.audio.onerror = function () {
                            console.log('Звук error')
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                })
            },

            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },

            skip: function () {
                this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
                this.taskIdx++
            },

            next: async function (item) {
                if(this.testmode==1) {
                    Vue.set(item, 'color', 'btn-answered')
                    await this.sleep(1000)
                    if(item.isright) this.$emit('correctAnswer')
                    else this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: `Неправильно выбран ответ: ${item.word}.`})
                    this.taskIdx++
                    return
                }

                if (item.isright) {
                    this.$emit('correctAnswer')
                    Vue.set(item, 'color', 'btn-success')
                    if (item.audio) {
                        await this.play(item.audio)
                    } else {
                        await this.play(this.okChord)
                    }
                }

                if (item.isright) {
                    this.taskIdx++
                } else {
                    Vue.set(item, 'color', 'btn-danger')
                    await this.play(this.errorChord)
                }
            },
        },
    }
</script>
